import React from 'react';
import { useFormContext, FieldError } from 'react-hook-form';
import { Checkbox } from '../ui/checkbox';
import type { Form } from '../../interfaces/form.interface';
import type { Metadata } from '../../interfaces/metadata.interface';
import { BaseField } from './BaseField';

interface CheckboxFieldProps {
  meta: Metadata;
  index: number;
  configuration: Form;
}

export const CheckboxField: React.FC<CheckboxFieldProps> = ({
  meta,
  index,
  configuration
}) => {
  const { register, formState: { errors } } = useFormContext();
  const error = errors[meta.id] as FieldError | undefined;

  return (
    <BaseField
      meta={meta}
      index={index}
      error={error}
      configuration={configuration}
    >
      <Checkbox
        id={meta.id}
        {...register(meta.id)}
        className={error ? 'border-red-500' : ''}
      />
    </BaseField>
  );
}; 